/**
 * ensure we do not track data on insight - to kibana
 */
const validateEnvironment = () => {
    return window.topContext.config.getSiteConfig().environment !== 'insight';
};

export default validateEnvironment;
